module.exports = __webpack_public_path__ + "static/img/B高清显示.5ebd575.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/360°全景环视系统/B高清显示.png
// module id = e8gm
// module chunks = 0